import React, { Fragment } from 'react';

const ImpressumText_de = (
  <Fragment>
    <h1 id="impressum">Impressum</h1>
    <p>
      <strong>
        Dieses Impressum gilt für die folgenden Webangebote des
        Umweltbundesamtes: Website des Data Cubes des Umweltbundesamtes (
        <a href="https://datacube.uba.de/">https://datacube.uba.de/</a>).
      </strong>
    </p>
    <h1 id="herausgeber">Herausgeber</h1>
    <p>Das Internetangebot wird herausgegeben von:</p>
    <p>
      Bundesrepublik Deutschland, vertreten durch das Bundesministerium für
      Umwelt, Naturschutz, nukleare Sicherheit und Verbraucherschutz (BMUV),
      dieses vertreten durch den Präsidenten des Umweltbundesamtes.
    </p>
    <p>
      <strong>Umweltbundesamt (UBA)</strong>
      <br />
      Fachgebiet I1.6 - Nationale und internationale Umweltberichterstattung
      <br />
      Wörlitzer Platz 1<br />
      06844 Dessau-Roßlau
    </p>
    <p>
      Fachgebiet I1.6
      <br />
      E-Mail:{' '}
      <a href="mailto:I1.5@uba.de">
        <strong>I1.5@uba.de</strong>
      </a>{' '}
    </p>
    <notes>
      {' '}
      (Bei der angegebene Mail-Adresse handelt es sich um ein Gruppen-Postfach)
    </notes>

    <p>
      Data Cube Team
      <br />
      E-Mail:{' '}
      <a href="mailto:datacube@uba.de">
        <strong>datacube@uba.de</strong>
      </a>{' '}
    </p>
    <notes>
      {' '}
      (Bei der angegebene Mail-Adresse handelt es sich um ein Gruppen-Postfach)
    </notes>

    <p>
      Umsatzsteuer-Identifikationsnummer gem. § 27a Umsatzsteuergesetz:
      DE811317238
    </p>
    <h1 id="verantwortlicher-im-sinne-des-medienstaatsvertrages">
      Verantwortlicher im Sinne des Medienstaatsvertrages
    </h1>
    <p>
      Michel Frerk
      <br />
      Projektleitung &quot;Data Cube&quot;{' '}
    </p>
    <p>
      Adresse: siehe oben
      <br />
      E-Mail:{' '}
      <a href="mailto:datacube@uba.de">
        <strong>datacube@uba.de</strong>
      </a>{' '}
    </p>
    <notes>
      {' '}
      (Bei der angegebene Mail-Adresse handelt es sich um ein Gruppen-Postfach)
    </notes>

    <h1 id="fachaufsicht">Fachaufsicht</h1>
    <p>
      Bundesministerium für Umwelt, Naturschutz, nukleare Sicherheit und
      Verbraucherschutz (BMUV)
    </p>
    <p>
      Stresemannstraße 128 - 130
      <br />
      10117 Berlin
      <br />
      Telefon: 030 18 305-0
      <br />
      Telefax: 0228 99 305-3225{' '}
    </p>
    <p>
      Internet: <a href="https://www.bmuv.de/">https://www.bmuv.de/</a>
    </p>
    <h1 id="inhalt-des-onlineangebotes">Inhalt des Onlineangebotes</h1>
    <p>
      Das Umweltbundesamt übernimmt keinerlei Gewähr für die Aktualität,
      Korrektheit, Vollständigkeit oder Qualität der bereitgestellten
      Informationen im Data Cube. Haftungsansprüche gegen das Umweltbundesamt,
      die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen
      bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen
      verursacht wurden, sind, soweit gesetzlich zulässig, grundsätzlich
      ausgeschlossen, sofern seitens des Umweltbundesamtes kein vorsätzliches
      oder grob fahrlässiges Verschulden vorliegt. Für Schäden aus der
      Verletzung des Lebens, des Körpers oder der Gesundheit haftet das
      Umweltbundesamt nach den gesetzlichen Bestimmungen. Alle Angebote des Data
      Cubes sind freibleibend und unverbindlich. Das Umweltbundesamt behält es
      sich ausdrücklich vor, Teile des Data Cubes oder das gesamte Angebot ohne
      gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die
      Veröffentlichung zeitweise oder endgültig einzustellen.
    </p>
    <p>
      Soweit die hier bereitgestellten Informationen Rechtsvorschriften,
      amtliche Hinweise, Empfehlungen oder Auskünfte enthalten, sind sie diese
      unter Beachtung größtmöglicher Sorgfalt erstellt. Bei Unklarheiten gilt
      jedoch ausschließlich die aktuelle amtliche Fassung, wie sie im dafür
      vorgesehenen amtlichen Verkündungsorgan veröffentlicht ist. Etwaige
      rechtliche Hinweise, Empfehlungen und Auskünfte sind rechtlich nicht
      verbindlich und stellen keine Rechtsberatung im Einzelfall dar. Die
      Informationen können und sollen eine Rechtsberatung nicht ersetzen. Bei
      konkreten juristischen Fragen sollte immer eine gesonderte fachjuristische
      Beratung erfolgen. Mit der reinen Nutzung dieser Internetseite kommt
      keinerlei Vertragsverhältnis zustande. Alle aus oder in Verbindung mit
      dieser Website entstehenden Rechtsstreitigkeiten unterliegen
      ausschließlich dem deutschen Recht. Gerichtsstand ist der Sitz des
      Umweltbundesamts.
    </p>
    <h1 id="verweise-und-links">Verweise und Links</h1>
    <p>
      Bei direkten oder indirekten Verweisen auf fremde Webseiten
      („Hyperlinks″), die außerhalb des Verantwortungsbereiches des
      Umweltbundesamtes liegen, würde eine Haftungsverpflichtung ausschließlich
      in dem Fall in Kraft treten, in dem das Umweltbundesamt von den Inhalten
      Kenntnis hat und es uns technisch möglich und zumutbar wäre, die Nutzung
      im Falle rechtswidriger Inhalte zu verhindern. Das Umweltbundesamt erklärt
      hiermit ausdrücklich, dass für uns zum Zeitpunkt der Linksetzung keine
      illegalen Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die
      aktuelle und zukünftige Gestaltung, die Inhalte oder die Urheberschaft der
      verlinkten/verknüpften Seiten hat das Umweltbundesamt keinerlei Einfluss.
      Deshalb distanzieren wir uns hiermit ausdrücklich von allen Inhalten aller
      verlinkten/verknüpften Seiten, die nach der Linksetzung verändert wurden.
      Dies gilt für alle innerhalb des eigenen Internetangebotes gesetzten Links
      und Verweise sowie für Fremdeinträge in Gästebüchern, Diskussionsforen,
      Linksammlungen und Mailinglisten. Für illegale, fehlerhafte oder
      unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung
      oder Nichtnutzung solcher dargebotener Informationen entstehen, haftet
      allein der Anbieter der Seite, auf welche verwiesen wurde, nicht
      derjenige, der über Links auf die jeweilige Veröffentlichung lediglich
      verweist. Internetseiten Dritter, die über externe Links erreicht werden,
      sind eventuell nicht barrierefrei gestaltet.
    </p>
    <h1 id="urheber-und-kennzeichenrecht">Urheber- und Kennzeichenrecht</h1>
    <p>
      Alle Rechte vorbehalten. Alle Inhalte der Internet-Präsenz unterliegen dem
      Schutz des deutschen Urheberrechts und anderer Schutzgesetze. Die Website
      nutzt die{' '}
      <a href="https://sis-cc.gitlab.io/dotstatsuite-documentation/about/license/">
        .Stat Suite Software
      </a>{' '}
      unter der <a href="https://mit-license.org/">MIT-Lizenz</a>. Das UBA ist
      bestrebt, in allen Publikationen die Urheberrechte an den verwendeten
      Grafiken, Tondokumenten, Videosequenzen und Texten zu beachten, von ihm
      selbst erstellte Grafiken, Tondokumente, Videosequenzen und Texte zu
      nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und
      Texte zurückzugreifen.{' '}
    </p>
    <p>
      Das Umweltbundesamt ist bestrebt, in allen Publikationen die Urheberrechte
      der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu
      beachten, von ihm selbst erstellte Grafiken, Tondokumente, Videosequenzen
      und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente,
      Videosequenzen und Texte zurückzugreifen. Alle innerhalb des
      Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und
      Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils
      gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen
      eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der
      Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt
      sind.
    </p>
    <p>
      Das Urheberrecht für veröffentlichte, vom Umweltbundesamt selbst erstellte
      Objekte bleibt allein beim Umweltbundesamt und den bearbeitenden
      Mitarbeiterinnen und Mitarbeitern der Seiten. Soweit nicht anders
      gekennzeichnet, stehen vom Umweltbundesamt selbst erstellte Objekte,
      Grafiken, Tondokumente, Videosequenzen und Texte auf dieser Website unter
      einer Creative Commons Namensnennung – Nicht kommerziell – keine
      Bearbeitungen 4.0 International Lizenz.
    </p>
    <p>
      Soweit nicht anders gekennzeichnet, ist die Nutzung von Daten im Sinne des
      § 12a EGovG zulässig. Die bereitgestellten Daten und ⁠Metadaten⁠ dürfen
      für die kommerzielle und nicht kommerzielle Nutzung insbesondere
    </p>
    <ol>
      <li>
        vervielfältigt, ausgedruckt, präsentiert, verändert, bearbeitet sowie an
        Dritte übermittelt werden
      </li>
      <li>
        mit eigenen Daten und Daten Anderer zusammengeführt und zu selbständigen
        neuen Datensätzen verbunden werden
      </li>
      <li>
        in interne und externe Geschäftsprozesse, Produkte und Anwendungen in
        öffentlichen und nicht öffentlichen elektronischen Netzwerken
        eingebunden werden.
      </li>
    </ol>
    <p>
      Bei der Nutzung ist sicherzustellen, dass das Umweltbundesamt im
      Quellenvermerk enthalten ist. Veränderungen, Bearbeitungen, neue
      Gestaltungen oder sonstige Abwandlungen sind im Quellenvermerk mit dem
      Hinweis zu versehen, dass die Daten geändert wurden.
    </p>
    <p>
      <br />
      <br />
    </p>
    <p>
      <notes>Letzte Aktualisierung dieser Seite: 17.05.2024</notes>
      <br />
      &copy; 2024 Umweltbundesamt Dessau-Roßlau. Alle Rechte vorbehalten
    </p>
  </Fragment>
);
export default ImpressumText_de;
